import { render } from "./CreatePR.vue?vue&type=template&id=5af7f5ce&scoped=true"
import script from "./CreatePR.vue?vue&type=script&lang=js"
export * from "./CreatePR.vue?vue&type=script&lang=js"

import "./CreatePR.vue?vue&type=style&index=0&id=5af7f5ce&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\IdeaProjects\\aipr-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af7f5ce"]])

export default __exports__